export function Logo({ size = 34 }: { size?: number }) {
  return (
    <div className="flex items-center gap-2.5">
      <img
        src="/assets/logo.png"
        alt="Orb Digital"
        width={512}
        height={403}
        style={{ height: size, width: 'auto' }}
        className="drop-shadow-[0_0_12px_rgba(139,60,240,0.7)]"
      />
      <span className="font-display text-lg font-semibold tracking-tight text-white">
        Orb<span className="text-orb-300">Digital</span>
      </span>
    </div>
  )
}
